export const sections = [
  {
    id: "introduction",
    titleKey: "content.sections.introduction.title",
    contentKey: "content.sections.introduction.content",
  },
  {
    id: "prism",
    titleKey: "content.sections.prism.title",
    contentKey: "content.sections.prism.content",
  },
  {
    id: "dexterity",
    titleKey: "content.sections.dexterity.title",
    contentKey: "content.sections.dexterity.content",
  },
  {
    id: "page",
    titleKey: "content.sections.page.title",
    contentKey: "content.sections.page.content",
  }
];
